jQuery(document).ready(function () {
    const $tables = jQuery('.bocss-table').not('.dataTable');

    if ($tables.length > 0) {
        updateResponsiveTables($tables);
        jQuery(window).on('resize', function () {
            updateResponsiveTables($tables);
        });
    }
});

function updateResponsiveTables($tables) {
    $tables.each(function () {
        const $table = jQuery(this);
        $table.removeClass('responsive');

        if ($table.outerWidth() > $table.parent().outerWidth()) {
            $table.addClass('responsive');
        }
    });
}
